// react components
import React, {
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    contentTypeDataSite,
    contentTypeModelTypeSite,
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
    reduxModalMainFormShowSite,
} from 'data'

// pages
import {
    AddButton825,
    Button825,
    ImageForm825,
} from 'pages'

// serializers
import {
    ContentTypeSettingsTypes,
} from 'serializers/site'

// props
type DetailAction825Props = {
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    detailObject: any
    disableOrdering?: boolean
    filterParams?: string
    hasOrdering: boolean
    inModal?: boolean
    isOrdering: boolean
    parentModelField: string
    parentObject: {
        id: number
        content_type_string: string
        content_uuid: string
        model_content_type_id: number
        profile?: any
    }
    refreshData: () => void
    setIsOrdering: (value: boolean) => void
    subContentType?: any
    subContentTypes?: any
}

// main
export const DetailTabAction825: React.FC<DetailAction825Props> = React.memo(({
    contentType,
    contentTypeSettings,
    detailObject,
    disableOrdering,
    filterParams,
    hasOrdering,
    inModal,
    isOrdering,
    parentModelField,
    parentObject,
    refreshData,
    setIsOrdering,
    subContentType,
    subContentTypes,
}) => {

    const dispatch = useDispatch()
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const [isImageFormOpen, setIsImageFormOpen] = useState(false)
    const [subContentTypesIsImageForm, setSubContentTypesIsImageForm] = useState(false)

    if (!parentObject.id) return null

    function onShowModalForm(subContentTypeId?: number) {
        try {
            const defaultFields = {
                [parentModelField]: parentObject,
            }
            // TODO check if dynamic possible
            if (parentModelField.includes('object_id')) {
                /// @ts-ignore
                defaultFields[parentModelField] = parentObject.id
                defaultFields['content_type'] = {
                    id: parentObject.model_content_type_id,
                    /// @ts-ignore
                    name: parentObject.content_type_string,
                }
            }
            // TODO
            if (subContentTypeId) {
                /// @ts-ignore
                defaultFields.sub_content_type = { id: subContentTypeId, name: subContentTypeId }
            } else if (subContentType) {
                defaultFields['sub_content_type'] = {
                    id: subContentType.id,
                    /// @ts-ignore
                    name: subContentType.id,
                }
            }
            if (filterParams?.includes('asset_custom_category')) {
                // @ts-ignore
                defaultFields['asset_custom_category'] = filterParams.split('&').find((param) => param.includes('asset_custom_category')).split('=')[1]
            }
            dispatch(reduxModalMainFormShowSite({
                contentType,
                contentTypeSettings,
                defaultFields,
                objectId: 'new',
                profileObject: parentObject.profile,
                refreshData,
            }))
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'DetailTabAction825',
                'onShowModalForm',
            ))
        }
    }

    return (
        <div className='detail-tab-action-825 DetailTabAction825'>
            {hasOrdering && (
                <Button825
                    disabled={disableOrdering}
                    edit={false}
                    onClick={() => setIsOrdering(!isOrdering)}
                    padding='0 10px 0 0'
                    size='x-small'
                    text={!isOrdering ? reduxText[10196] : reduxText[10197]}
                />
            )}
            {!contentTypeSettings.meta.disableFormAdd && (
                <AddButton825
                    inModal={inModal}
                    onShowModalForm={(subContentTypeId?: number, isImage?: boolean) => {  // TODO dynamic
                        if (subContentTypeId) {
                            if (isImage) {
                                // @ts-ignore
                                setSubContentTypesIsImageForm({ id: subContentTypeId, name: subContentTypeId })
                            } else {
                                onShowModalForm(subContentTypeId)
                            }
                        } else if (subContentType) {
                            if (subContentType.isImage) {
                                setIsImageFormOpen(true)
                            } else {
                                onShowModalForm()
                            }
                        } else if ([contentTypeDataSite['datapool_asset'], contentTypeDataSite['staff_staffmessageimage']].includes(contentTypeSettings.meta.model_content_type_id)) {
                            setIsImageFormOpen(true)
                        } else {
                            onShowModalForm()
                        }
                    }}
                    size='x-small'
                    subContentTypes={subContentTypes}
                />
            )}
            {isImageFormOpen && (
                <ImageForm825
                    contentType={contentType}
                    detailObject={detailObject}
                    filterParams={filterParams}
                    refreshData={refreshData}
                    setIsOpen={setIsImageFormOpen}
                    subContentType={subContentType}
                />
            )}
            {subContentTypesIsImageForm && (
                <ImageForm825
                    contentType={contentType}
                    detailObject={detailObject}
                    filterParams={filterParams}
                    refreshData={refreshData}
                    setIsOpen={setSubContentTypesIsImageForm}
                    subContentType={subContentTypesIsImageForm}
                />
            )}
        </div>
    )
})
